import { RootState } from "@/modules/common";

export const selectCustomer = (state: RootState) => state.customers;
